import client from "../Client/HttpClient";
import { IPeriodsModel } from "@/interfaces/modules";
const ApiPath = "Periods";

export default {
  GetPeriods: (): Promise<IPeriodsModel[]> => client.get(`${ApiPath}`),
  GetPeriodsById: (data: IPeriodsModel): Promise<IPeriodsModel> => client.get(`${ApiPath}/${data.Id}`),
  PostPeriods: (data: IPeriodsModel): Promise<IPeriodsModel> => client.post(`${ApiPath}`, data),
  GetPeriodsByAcademicYear: (data: { AcademicYearId: number }) => client.get(`${ApiPath}/byYear/${data.AcademicYearId}`),
  GetCurrentPeriodByAcademicYear: (data: { AcademicYearId: number }) => client.get(`${ApiPath}/current/${data.AcademicYearId}`),
};